import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { kesariAnimations } from 'src/app/animation';
import { ShareService } from 'src/app/service/share.service';

@Component({
  selector: 'app-careerform',
  templateUrl: './careerform.component.html',
  styleUrls: ['./careerform.component.scss'],
  animations: kesariAnimations,
})
export class CareerformComponent implements OnInit {
  CareerForm: FormGroup;
  submitted = false;
  thankYouMessageVisible = false;
  disableSubmitbtn: boolean = false;
  formview = true
  errorMessage: string;
  miceResume
  title = 'Application Form'
  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<CareerformComponent>,
    private careerService: ShareService,
    private toastrService: ToastrService,
  ) { }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(): void {
    this.CareerForm = this.formBuilder.group({
      noticePeriod: [''],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      email: ["", [Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/),]],
      mobileNo: ['', [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
      ctc: [''],
      location: [''],
      presentEmployer: [''],
      applyFor: ['', Validators.required],
      scheduleDate: ['', [this.scheduleDateValidator]],
      bod: ['', [this.dateOfBirthValidator]],
      resume: ['', [Validators.required, this.fileFormatValidator(['pdf', 'doc', 'docx'])]]
    });
  }
  public checkError = (controlName: string, errorName: string) => {
    return this.CareerForm.controls[controlName].hasError(errorName);


  }

  dateOfBirthValidator(control: FormControl): { [key: string]: any } | null {
    const inputDate = new Date(control.value);
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 30)
    if (inputDate >= (currentDate)) {

      return { 'invalidDate': true };
    }

    return null;
  }

  scheduleDateValidator(control: FormControl): { [key: string]: any } | null {
    const inputDate = new Date(control.value);
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1)
    if (inputDate <= (currentDate)) {

      return { 'invalidDate': true };
    }

    return null;
  }

  onSubmit(): void {

    if (this.CareerForm.valid) {
      // this.submitted = true;

      // const resume = JSON.parse(resume);
      // console.log(residential_address, residential_addressObj)

      this.CareerForm.value.resume = this.miceResume;
     // console.log(this.CareerForm.value);
      // this.formview=false;
      // this.title=''

      // this.thankYouMessageVisible = true;
      this.careerService.getCareer(this.CareerForm.value)
        .subscribe(
          response => {
            //console.log('API Response:', response);
            if (response.message == "Successfully Saved Your Request") {
              this.toastrService.success(
                "Your Application Submitted succesfully!",
                "Thank you",
                {
                  //positionClass: "toast-top-center",
                }
              );
              //this.CareerForm.reset();
              this.closeDialog();
            }
         
          },
          error => {
            this.toastrService.error(
              "Form Submission Failed"
            );
          }
        );
    }
    else {
      this.errorMessage = "Form has some Issues"; //Error Mesage
      // this.loading = false;
      this.toastrService.error(
        "Form Submission Failed"
      );
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  onFileChange(event: any): void {

    const file = event.target.files[0];
    this.CareerForm.patchValue({ resume: file });
    this.CareerForm.get('resume').markAsTouched();
    var fd = new FormData();
    fd['file'] = file;
    fd.append('path', "MiceResume");
    fd.append('file', file);
    fd['path'] = "MiceResume";
    //console.log('file', fd)
    this.careerService.upLoadResume(fd).subscribe((res) => {
      // console.log(res)
      if (res.message == "success") {
        this.miceResume = res.url
      }

    })

  }
  fileFormatValidator(allowedFormats: string[]) {
    return (control: FormControl): { [key: string]: any } | null => {
      const file = control.value;
      if (file) {
        const fileExtension = file.name.split('.').pop()?.toLowerCase();
        if (!allowedFormats.includes(fileExtension)) {
          return { invalidFormat: true };
        }
      }
      return null;
    };
  }
}
